export default {
  namespaced: true,
  state: {
    items: [],
    breadcrumb: []
  },
  mutations: {
    init(state, data) {
      state.items = data;
    },
    setBreadcrumb(state, data) {
      state.breadcrumb = data;
    }
  },
  actions: {
    async init(store) {
      const dashboards = await store.dispatch('reporting/fetchLinks', null, {root: true});
      const pigStyDashboards = dashboards.filter(d => d.position === 'PigSty').map(item => {
        return {
          name: item.name,
          url: `/reports/dashboard/${item.id}`
        }
      });

      const personParentId = 0;
      const masterDataParentId = 5;
      const systemParentID = 6;
      const items = [
        {
          name: 'Personen',
          url: '/person',
          icon: 'fas fa-users',
          children: []
        },
        {
          name: 'Mast',
          icon: 'fas fa-pig',
          children: [{
            name: 'Einteilung',
            url: '/transport/overview'
          }, {
            name: 'Verrechnung',
            url: '/delivery/billing'
          }, {
            name: 'Abrechnung',
            url: '/delivery/complete'
          },
            {
              name: 'Lohnmast',
              url: '/delivery/from-hire'
            },
            {
              name: 'Lieferprogramme',
              url: '/delivery-program/overview'
            },
            {
              name: 'Zu- Abschläge',
              children: [
                {
                  name: 'Parameter',
                  url: '/additions/overview'
                },
                {
                  name: 'Summenzuschläge',
                  url: '/summary-additions/overview'
                },
                {
                  name: 'Warenwert Konto',
                  url: '/additions/accounts'
                }
              ]
            },
            {
              name: 'Artikelverwaltung',
              url: '/article',
              children: [
                {
                  name: 'Artikel',
                  url: '/article/overview',
                },
                {
                  name: 'Gruppen',
                  url: '/article/groups',
                },
                {
                  name: 'Testschweine',
                  url: '/article/test-pigs',
                },
                {
                  name: 'Auswertungen',
                  url: '/article/individual-reports',
                }
              ]
            },
            {
              name: 'Meldegruppen',
              url: '/registration/groups'
            },
            {
              name: 'Manueller Beleg',
              url: '/pig-let/document/manual/pigsty'
            },
            {
              name: 'Auswertungen',
              url:'/reports',
              children: pigStyDashboards
            },
            {
              name: 'ZSDB',
              url: '/pig-let/zsdb/PigSty'
            },
            {
              name: 'ELBA/FIBU',
              url: '/pig-let/finance/PigSty'
            }
          ]
        },
        {
          name: 'Ferkel',
          url: '/pig-let',
          icon: 'fad fa-pig',
          children: [
            {
              name: 'Einteilung',
              url: '/pig-let/transport/management'
            },
            {
              name: 'Lieferscheine',
              url: '/pig-let/delivery-list/piglet'
            },
            {
              name: 'Artikel',
              url: '/pig-let/article/piglet'
            },
            {
              name: 'Mengenstaffel',
              url: '/pig-let/quantity-scale/piglet'
            },
            {
              name: 'Zu- Abschläge',
              url: '/pig-let/additions'
            },
            {
              name: 'Transport',
              url: '/pig-let/transport'
            },
            {
              name: 'Vermarktung',
              url: '/pig-let/marketing-fee'
            },
            {
              name: 'Meldezeitpunkte',
              url: '/pig-let/registration-deadline/piglet'
            },
            {
              name: 'Manueller Beleg',
              url: '/pig-let/document/manual/piglet'
            },
            {
              name: 'Artikelnachverrechnung',
              url: '/master-data/manual-reasons'
            },
            {
              name: 'ZSDB',
              url: '/pig-let/zsdb/Piglet'
            },
            {
              name: 'ELBA/FIBU',
              url: '/pig-let/finance/piglet'
            }
          ]
        },
        {
          name: 'Babyferkel',
          url: '/pig-let',
          icon: 'far fa-pig',
          children: [
            {
              name: 'Lieferscheine',
              url: '/pig-let/delivery-list/baby-piglet'
            },
            {
              name: 'Artikel',
              url: '/pig-let/article/baby-piglet'
            },
            {
              name: 'Mengenstaffel',
              url: '/pig-let/quantity-scale/baby-piglet'
            },
            {
              name: 'Zu- Abschläge',
              url: '/pig-let/additions'
            },
            {
              name: 'Transport',
              url: '/pig-let/transport-babypiglet'
            },
            {
              name: 'Vermarktung',
              url: '/pig-let/marketing-fee'
            },
            {
              name: 'Preisformel',
              url: '/baby-pig-let/price-formula'
            },
            {
              name: 'ELBA/FIBU',
              url: '/pig-let/finance/baby-piglet'
            }
          ]
        },
        {
          name: 'Ohrmarken',
          url: '/earmark',
          icon: 'far fa-bookmark',
          children: [{
            name: 'Bestellungen',
            url: '/earmarks/orders'
          }, {
            name: 'Kategorien',
            url: '/earmarks/categories'
          }, {
            name: 'Preise',
            url: '/earmarks/default-price'
          }]
        },
        {
          name: 'Stammdaten',
          url: '/master-data',
          icon: 'fas fa-database',
          children: []
        },
        {
          name: 'System',
          url: '/system',
          icon: 'fas fa-network-wired',
          children: []
        },
        {
          name: 'Reports',
          url: '/reports/overview',
          icon: 'fas fa-file-chart-pie',
        }
      ];

      //person
      items[personParentId].children.push({
        name: 'Übersicht',
        url: '/persons/overview'
      });

      items[personParentId].children.push({
        name: 'Personen',
        url: '/persons/list',
      });

      items[personParentId].children.push({
        name: 'Betriebe',
        url: '/factories/overview'
      });

      items[personParentId].children.push({
        name: 'Schlachthöfe',
        url: '/slaughter-houses/overview'
      });

      items[personParentId].children.push({
        name: 'Tierärzte',
        url: '/veterinarians/overview'
      });

      //master-data
      items[masterDataParentId].children.push({
        name: 'Anrede',
        url: '/master-data/salutations'
      });
      items[masterDataParentId].children.push({
        name: 'Orte',
        url: '/master-data/places'
      });
      items[masterDataParentId].children.push({
        name: 'Titel',
        url: '/master-data/titles'
      });
      items[masterDataParentId].children.push({
        name: 'Banken',
        url: '/master-data/banks'
      });

      items[masterDataParentId].children.push({
        name: 'Steuersätze',
        url: '/master-data/taxes'
      });

      items[masterDataParentId].children.push({
        name: 'Zahlungsbed.',
        url: '/master-data/payments'
      });

      items[masterDataParentId].children.push({
        name: 'Betriebsarten',
        url: '/master-data/business-mode'
      });

      items[masterDataParentId].children.push({
        name: 'Nummernkreise',
        url: '/master-data/number-ranges'
      });

      items[masterDataParentId].children.push({
        name: 'Einstellplätze',
        url: '/master-data/production-spaces'
      });

      items[masterDataParentId].children.push({
        name: 'Schweinepreise',
        url: '/master-data/pig-prices'
      });

      items[masterDataParentId].children.push({
        name: 'LKW',
        url: '/master-data/transporter'
      });

      items[masterDataParentId].children.push({
        name: 'Beleggruppen',
        url: '/blob/groups'
      });
      items[masterDataParentId].children.push({
        name: 'Artikelnachverrechnung',
        url: '/master-data/manual-reasons'
      });

      items[masterDataParentId].children.push({
        name: 'Konten',
        url: '/master-data/booking-accounts'
      });

      if (this.$auth.hasClaim('StyGateway', 'View')) {
        items[systemParentID].children.push({
          name: 'Services',
          url: '/system/services'
        });
      }

      if (this.$auth.hasClaim('StyUserManagement', 'View')) {
        items[systemParentID].children.push({
          name: 'Benutzer',
          url: '/system/user-management'
        });
      }
      store.commit('init', items);
    },
    setBreadcrumb({commit}, data) {
      commit('setBreadcrumb', data);
    }
  }
}
